module.exports = __webpack_public_path__ + "img/circleOrange2.0d515160.svg";